<template>
  <div class="multiomics" @click="showExist = false">
    <div class="userMessage">
      <van-icon class="ellipsis" name="ellipsis" @click.stop="showExist = !showExist" />
      <SideBar :show="showExist"></SideBar>
      <div class="icon">
        <img src="../../assets/images/multiomics/head.png" alt="">
      </div>
      <div>
        <p><span class="name">{{ phone | phone }} </span> </p>
        <p class="code">欢迎您！</p>
      </div>
    </div>
    <div class="mainBox" v-show="groups.length > 1">
      <div class="main">
        <div v-for="(item, index) in groups" :key="index" @click="handleClick(item.name, item.riskStatus, index)">
          <div class="sample" :style="{ 'background': (active == index ? '#3CE0FB' : 'none')}">
            <img src="../../assets/images/multiomics/father.png" alt="">
            <p>{{ item.name }}</p>
          </div>
        </div>
      </div>
    </div>
    <div v-show="geneShow" class="listBox">
      <div class="list">
        <div class="title">
          <i class="iconfont iconhebingxingzhuang"></i>
          <span>基因组学</span>
        </div>
        <!-- <div class="content" v-for="(item, index) in scodeData.gene" :key="index" @click="accessReport(item.access_token, item.status)"> -->
        <div class="content" v-for="(item, index) in scodeData.gene" :key="index" @click="accessReport(item)">
          <img src="../../assets/images/multiomics/report1.png" alt="">
          <span>{{ item.sample_name }}({{ item.sample_code }})</span>
        </div>
        <div class="content gray">
          <div @click="$router.push('/coming')">
            <img src="../../assets/images/multiomics/noreport.png" alt="">
            <span>遗传性心血管病风险筛查</span>
          </div>
        </div>
        <p class="red" v-show="isShow">说明：不同的基因产品由于算法、入选位点的差异，可能导致同一解 读项在不同的报告中结果不同。</p>
      </div>
    </div>
    <div v-show="metabolismShow" class="listBox">
      <div class="list">
        <div class="title">
          <i class="iconfont iconbingli"></i>
          <span>代谢组学</span>
        </div>
        <div class="content" :class="{ gray: metabolism.length === 0 }">
          <div v-if="metabolism.length === 0" @click="noCer">
            <img src="../../assets/images/multiomics/noreport.png" alt="">
            <span>CER-心血管病风险评估</span>
          </div>
          <div v-else>
            <div class="content_item" v-for="(item, index) in metabolism" :key="index" @click="cerReport(item.access_token, item.sample_code)">
              <img src="../../assets/images/multiomics/report1.png" alt="">
              <span>{{ item.sample_name }}({{ item.sample_code }})</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div  v-show="riskShow" class="listBox">
      <div class="list">
        <div class="title">
          <i class="iconfont iconleshenghuo"></i>
          <span>风险评估</span>
        </div>
        <div class="content">
          <div @click="$router.push('/assessment')">
            <img src="../../assets/images/multiomics/report1.png" alt="">
            <span>传统风险评估</span>
          </div>
        </div>
        <div class="content">
          <div @click="$router.push('/currentIndex')">
            <img src="../../assets/images/multiomics/report1.png" alt="">
            <span>健康现状调查</span>
          </div>
        </div>
      </div>
    </div>

    <div v-show="mulConShow" class="listBox">
      <div class="list">
        <div class="title">
          <i class="iconfont iconzhenduanbaogao"></i>
          <span>多组学综合结论</span>
        </div>
        <div class="content">
          <div @click="goConclusion">
            <img src="../../assets/images/multiomics/report1.png" alt="">
            <span>心血管病综合结论</span>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import SideBar from '@/components/SideBarHome.vue'
import { Dialog } from 'vant'
export default {
  name: 'index',
  data () {
    return {
      geneShow:true,
      metabolismShow:true,
      mulConShow:true,
      riskShow:true,
      active: this.util.getLS('activeNum') || 0,
      showExist: false,
      phone: '',
      groups: [],
      scodeData: [],
      metabolism: [],
      gender: '',
      name: '',
      scode: '',
      isShow: false,
      riskStatus: false
    }
  },
  components: {
    SideBar,
    Dialog
  },
  filters: {
    phone: function (value) {
      return value.substring(0, 3) + ' ' + value.substring(3, 7) + ' ' + value.substring(value.length - 4)
    }
  },
  methods: {
    // 综合结论入口
    goConclusion () {
      if (this.metabolism.length > 0) {
        let token = this.metabolism[0].access_token
        this.util.setLS(this.api.access_token, token)
        this.util.get(this.api.car_status, '', (success) => {
          if (success.status) {
            this.$router.push('/conclusion')
          } else {
            Dialog.alert({
              title: '提示',
              message: '您缺少动态风险数据和代谢物神经酰胺数据，请及时补充完整'
            }).then(() => {
              // on close
            })
          }
        })
      } else if (this.metabolism.length === 0 && this.riskStatus) {
        let token = this.scodeData.gene[0].access_token
        this.util.setLS(this.api.access_token, token)
        this.$router.push('/conclusion')
      } else {
        Dialog.alert({
          title: '提示',
          message: '您缺少动态风险数据和代谢物神经酰胺数据，请及时补充完整'
        }).then(() => {
          // on close
        })
      }
    },
    // 无cer
    noCer () {
      Dialog.alert({
        title: '提示',
        message: '您缺少CER-心血管病风险评估数据，请及时检测。'
      }).then(() => {
        // on close
      })
    },
    // 神经酰胺入口
    cerReport (token, scode) {
      this.util.get(this.api.cer_status, '', (success) => {
        if (success.status) {
          this.util.setLS(this.api.access_token, token)
          this.util.setLS('sample_code', scode)
          this.$router.push('/ceramide')
        } else {
          Dialog.alert({
            title: '提示',
            message: '暂未完成检测，请耐心等待。'
          }).then(() => {
            // on close
          })
        }
      })
    },
    // 访问报告
    // accessReport (token, status) {
    accessReport (itemVal) {
      const {access_token,status,product_type} = itemVal
      this.util.setLS(this.api.status, status)
      this.util.setLS(this.api.access_token, access_token)
      if(product_type === 2){
        this.$router.push('/small/home')
      }else{
        this.$router.push('/home')
      }
    },
    // 选择样本
    handleClick (name, riskStatus, i) {
      this.name = name
      this.riskStatus = riskStatus
      this.active = i
      this.util.setLS('activeNum', this.active)
      this.groups.forEach(item => {
        if (this.name === item.name) {
          this.scodeData = item.samples
          this.metabolism = this.scodeData.metabolism
        }
      })
    },
    select () {
      let data = new FormData()
      data.append('uid', this.util.getLS(this.api.uid) * 1)
      data.append('access_token', JSON.stringify(this.util.getLS('access_token')))
      this.util.post(this.api.select, data, (success) => {
        this.phone = success.phone
        this.groups = success.groups.filter(function (element, index, self) {
          return self.findIndex(el => el.name === element.name) === index
        })
        this.geneShow = success.show.geneShow
        this.metabolismShow = success.show.metabolismShow
        this.mulConShow = success.show.mulConShow
        this.riskShow = success.show.riskShow
        this.name = success.groups[0].name
        this.riskStatus = success.groups[this.active].riskStatus
        this.scodeData = success.groups[this.active].samples
        this.metabolism = this.scodeData.metabolism
        this.groups.forEach(item => {
          if (item.samples.gene.length > 1) {
            this.isShow = true
          }
        })
      })
    }
  },
  mounted () {
    let token = this.$route.query.token
    if (token) {
      this.util.setLS(this.api.access_token, token)
    }
    this.select()
  }
}
</script>

<style lang="scss">
  @import "../../assets/scss/functions";
  .multiomics {
    width: 100%;
    height: 100%;
    background: #ECEEF0;
    overflow: auto;

    .userMessage {
      position: relative;
      width: 100%;
      padding: pxToRem(120px) pxToRem(100px);
      background: linear-gradient(to right, #039ACD, #01D1E3);
      /*background: #08A0CC;*/
      display: flex;
      flex-direction: row;
      align-items: center;

      .ellipsis {
        position: absolute;
        top: pxToRem(20px);
        right: pxToRem(30px);
        font-size: pxToRem(40px);
        color: #fff;
      }

      .icon {
        width: pxToRem(95px);
        height: pxToRem(95px);
        border: pxToRem(5px) solid #47dedd;
        line-height: pxToRem(130px);
        border-radius: 50%;
        text-align: center;
        margin-right: pxToRem(20px);
        background-color: #c7f5f5;

        img {
          width: 100%;
        }

        .iconfont {
          font-size: pxToRem(100px);

          &.iconsexBoy {
            color: #00a0e8;
          }

          &.iconsexGirl {
            color: #e800db;
          }
        }
      }

      p {
        color: #fff;
        font-size: pxToRem(20px);

        &.code {
          font-size: pxToRem(25px);
        }

        .name {
          font-size: pxToRem(44px);
        }
      }
    }

    .mainBox {
      position: relative;
      z-index: 11;
      clear: both;
      width: 100%;
      padding: pxToRem(20px) pxToRem(30px);
      padding-bottom: 0;
      margin-top: pxToRem(-80px);

      .main {
        background-color: #fff;
        border-radius: pxToRem(20px);
        padding: pxToRem(30px);
        z-index: 11;
        font-size: pxToRem(33px);
        overflow: auto;
        white-space: nowrap;
        border: 1px solid #D8DBDA;

        >div {
          display: inline-block;
        }

        .sample {
          position: relative;
          margin: 0 pxToRem(20px);
          background: #3CE0FB;
          width: pxToRem(180px);
          height: pxToRem(150px);
          border: 1px solid #3CE0FB;
          border-radius: pxToRem(20px);

          img{
            display: block;
            width: pxToRem(90px);
            margin: pxToRem(10px) auto;
          }
          p {
            position: absolute;
            left: 0;
            bottom: 0;
            width: 100%;
            color: #fff;
            text-align: center;
            font-size: pxToRem(28px);
            border-radius: 0 0 pxToRem(20px) pxToRem(20px);
            background: linear-gradient(#02FCFF, #04C7FF);
          }
        }
      }
    }
    .listBox {
      clear: both;
      width: 100%;
      padding: 0 pxToRem(30px);

      .list {
        background-color: #fff;
        border: 1px solid #D8DBDA;
        border-radius: pxToRem(20px);
        padding: pxToRem(30px);
        margin: pxToRem(30px) 0;
        font-size: pxToRem(33px);

        .title {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          margin-top: pxToRem(10px);
          margin-left: pxToRem(20px);

          i {
            font-size: pxToRem(70px);
            /*transform: rotate(90deg);*/
            color: #11BBDA;
          }
          span {
            font-size: pxToRem(40px);
            letter-spacing: 0.1em;
            color: #11BBDA;
            background-image: -webkit-linear-gradient(left bottom, #08A0CC, #16CDE3);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            margin-left: pxToRem(20px);
          }
        }
        .content {
          display: flex;
          font-size: pxToRem(30px);
          margin: pxToRem(40px) 0 pxToRem(40px) pxToRem(110px);
          img {
            width: pxToRem(38px);
            height: pxToRem(48px);
            vertical-align: middle;
          }
          span {
            margin-left: pxToRem(20px);
          }
          .content_item {
            margin-bottom: pxToRem(30px);
          }
        }
        .red {
          font-size: pxToRem(20px);
          color: red;
          text-indent: -3.6em;
          padding-left: 6em;
          padding-bottom: pxToRem(30px);
        }
      }
    }
    .gray *{
      color: #BFBFBF!important;
      span {
        background-image: none!important;
        -webkit-text-fill-color: #BFBFBF!important;
        margin-left: pxToRem(20px);
      }
    }
    .gray .content {
      margin-bottom: pxToRem(120px)!important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/multiomics/index.vue